




import { Component, Vue, Watch } from 'vue-property-decorator';
import { OidcLogin } from '@/globals/oidc-login';
import { Action, Getter, Mutation } from 'vuex-class';
import { GET_OIDC_USER_MANAGER, OIDC_USER_MANAGER, SET_OIDC_ID } from '@/types/authentication.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { OidcUserManager } from '@/models/OidcUserManager.model';

@Component({})
export default class OidcComponent extends Vue {

  @Action(GET_OIDC_USER_MANAGER, StoreNamespace.AUTHENTICATION) public getOidcUserManager;

  @Mutation(SET_OIDC_ID, StoreNamespace.AUTHENTICATION) public setOidcId;

  @Getter(OIDC_USER_MANAGER, StoreNamespace.AUTHENTICATION) public oidcUserManager!: OidcUserManager;

  public mounted() {
    const route = this.$route;
    const oidcId = route.params?.id;
    this.setOidcId(oidcId);
    this.getOidcUserManager(oidcId);
  }

  @Watch('oidcUserManager')
  private onOidcUserManagerChanged() {
    OidcLogin.getUserManager(this.oidcUserManager).signinRedirect().catch(err => {
      console.log(err);
    });
  }
}
